import * as stylex from '@stylexjs/stylex';
import { styles } from './styles.ts';
import { SminexEventIcon } from '@shared/assets/icons';
import { colors } from '@shared/tokens/colors.stylex';
import { FC, ReactNode } from 'react';

interface BasicLayoutProps {
  children: ReactNode;
}

export const BasicLayout: FC<BasicLayoutProps> = ({ children }) => {
  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.logo)}>
        <SminexEventIcon colorPrimary={colors.primaryText} colorSecondary={colors.accentBackground} />
      </div>
      {children}
    </div>
  );
};
